<div [formGroup]="filterForm" class="mb-4 flex flex-col gap-6 rounded-lg border border-gray-200 bg-white p-6 filters-shadow">
  <div class="grid grid-cols-3 gap-6">
    <div class="group relative">
      <label
        for="statusId"
        class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
        i18n="@@adminPharmaciesFilterStatus">
        Status
      </label>
      <div class="status-dropdown-container relative">
        <!-- Trigger Button -->
        <button
          type="button"
          (click)="toggleStatusDropdown()"
          class="flex w-full appearance-none items-center justify-between rounded-[10px] border border-gray-400 bg-white py-2.5 pr-10 pl-4 text-[14px] text-gray-700 transition-colors outline-none hover:cursor-pointer hover:border-gray-600 focus:border-black">
          <span class="truncate">
            @if (selectedStatusIds()?.length === 0) {
              <span class="text-gray-400" i18n="@@adminPharmaciesFilterStatusTitle">Filter by status</span>
            } @else {
              {{ selectedStatusIds()?.length }} {{ isArabic() ? "محدد" : "selected" }}
            }
          </span>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="pointer-events-none h-5 w-5 text-black transition-transform"
            [class.rotate-180]="showStatusDropdown()"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        <!-- Dropdown List -->
        @if (showStatusDropdown()) {
          <div class="absolute z-50 mt-1 w-full rounded-[10px] border border-gray-200 bg-white shadow-lg">
            <!-- All Statuses option -->
            <div
              (click)="toggleStatus(undefined)"
              class="flex cursor-pointer items-center gap-2 px-4 py-2.5 text-[14px] hover:bg-gray-50">
              <div
                class="flex h-4 w-4 items-center justify-center rounded border-2"
                [class.border-black]="isStatusSelected(undefined)"
                [class.bg-black]="isStatusSelected(undefined)"
                [class.border-gray-300]="!isStatusSelected(undefined)">
                @if (isStatusSelected(undefined)) {
                  <svg
                    class="h-2.5 w-2.5 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="3">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                }
              </div>
              <span i18n="@@adminPharmaciesFilterAllStatuses">All Statuses</span>
            </div>

            <hr class="border-gray-100" />

            <!-- Status options -->
            @for (status of statuses(); track status.id) {
              <div
                (click)="toggleStatus(status.id)"
                class="flex cursor-pointer items-center gap-2 px-4 py-2.5 text-[14px] hover:bg-gray-50">
                <div
                  class="flex h-4 w-4 items-center justify-center rounded border-2"
                  [class.border-black]="isStatusSelected(status.id)"
                  [class.bg-black]="isStatusSelected(status.id)"
                  [class.border-gray-300]="!isStatusSelected(status.id)">
                  @if (isStatusSelected(status.id)) {
                    <svg
                      class="h-2.5 w-2.5 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="3">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  }
                </div>
                <span>{{ isArabic() ? status.titleAr : isEnglish() ? status.titleEn : "" }}</span>
              </div>
            }
          </div>
        }
      </div>
    </div>

    <div class="group relative">
      <label
        for="lastModifiedOnFrom"
        class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-black transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
        i18n="@@lastModificationDateFrom">
        Last Modification Date (From)
      </label>
      <div class="relative">
        <input
          type="date"
          id="lastModifiedOnFrom"
          name="lastModifiedOnFrom"
          formControlName="lastModifiedOnFrom"
          [max]="today()"
          [class.border-red-500]="
            filterForm.get('lastModifiedOnFrom')?.invalid && filterForm.get('lastModifiedOnFrom')?.touched
          "
          class="w-full appearance-none rounded-[10px] border border-gray-400 bg-white px-4 py-2.5 text-[14px] text-gray-400 transition-colors outline-none placeholder:text-gray-400 hover:cursor-text hover:border-gray-600 focus:border-black" />
      </div>
    </div>

    <div class="group relative">
      <label
        for="createdOnTo"
        class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-black transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
        i18n="@@lastModificationDateTo">
        Last Modification Date On (To)
      </label>
      <div class="relative">
        <input
          type="date"
          id="lastModifiedOnTo"
          name="lastModifiedOnTo"
          formControlName="lastModifiedOnTo"
          [min]="filterForm.get('lastModifiedOnFrom')?.value || ''"
          [max]="today()"
          [class.border-red-500]="
            filterForm.get('lastModifiedOnTo')?.invalid && filterForm.get('lastModifiedOnTo')?.touched
          "
          class="w-full appearance-none rounded-[10px] border border-gray-400 bg-white px-4 py-2.5 text-[14px] text-gray-400 transition-colors outline-none placeholder:text-gray-400 hover:cursor-text hover:border-gray-600 focus:border-black" />
      </div>
    </div>
  </div>

  <div class="mt-4 flex justify-between gap-4">
    <div class="flex flex-1 gap-4">
      <div class="group relative max-w-[200px] flex-1">
        <label
          for="orderBy"
          class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3"
          i18n="@@userPharmaciesSortByLabel">
          Sort By
        </label>
        <div class="flex items-center gap-2">
          <span
            class="block w-fit rounded-[10px] border border-gray-400 bg-white px-4 py-2.5 text-[14px] whitespace-nowrap text-gray-700"
            i18n="@@adminPharmaciesSortLastModified">
            Last Modified
          </span>

          <button
            (click)="onToggleSortOrder()"
            class="w-[100px] rounded-[10px] border border-gray-400 bg-white px-2.5 py-2.5 text-[14px] font-[500] text-gray-700 transition-colors hover:cursor-pointer hover:border-gray-600 hover:bg-gray-50 focus:border-black focus:outline-none">
            @if (filters().orderDir == "DESC") {
              <span i18n="@@adminCategoriesSortAsc">ASC</span>
            } @else {
              <span i18n="@@adminCategoriesSortDesc">DESC</span>
            }
          </button>
        </div>
      </div>
      <!-- <button
        (click)="onToggleSortOrder()"
        class="rounded-[10px] border border-gray-400 px-4 py-2 text-[14px] font-[500] text-gray-700 transition-colors hover:cursor-pointer hover:border-gray-600 hover:bg-gray-50 focus:border-black focus:outline-none"> -->
      <!-- {{ getSortLabel() }} -->
      <!-- </button> -->
    </div>
    <div class="flex items-end justify-end gap-3">
      <button
        (click)="onResetFilters()"
        class="border-primary text-primary hover-bg-primary-10 rounded-[6px] border px-8 py-2 text-[13px] font-[500] transition-colors hover:cursor-pointer"
        i18n="@@userPharmaciesResetButton">
        Clear
      </button>
      <button
        (click)="onApplyFilters()"
        class="bg-primary hover-bg-primary-hover rounded-[6px] px-8 py-2 text-[13px] font-[500] text-white transition-colors hover:cursor-pointer"
        i18n="@@userPharmaciesApplyButton">
        Apply
      </button>
    </div>
  </div>
</div>
